import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';

import { Environments, initializePaddle } from '@paddle/paddle-js';

// Utils
import { useCheckoutLink } from '@/utils/hooks/swr/pricing/useCheckoutLink';
import useSubscription from '@/utils/hooks/swr/pricing/useSubscription';

// Lib
import { CHECKOUT } from '@/lib/routes/privateRoutes';

const URLS_PADDLE_ALREADY_INITIALIZED = [CHECKOUT];

export function PaddleInitialize() {
    if (window?.Paddle) {
        return null;
    }

    return <LaunchPaddle />;
}

function LaunchPaddle() {
    const [isInitialized, setIsInitialized] = useState(false);
    const pathname = usePathname();
    const { subscription } = useSubscription();
    const productId = subscription && 'product_id' in subscription ? subscription.product_id : null;
    const { checkoutLink } = useCheckoutLink({ product_id: productId });

    useEffect(() => {
        if (
            checkoutLink?.customer_id &&
            !URLS_PADDLE_ALREADY_INITIALIZED.includes(pathname) &&
            !isInitialized
        ) {
            initializePaddle({
                environment: process.env.NEXT_PUBLIC_PADDLE_ENVIRONMENT as Environments,
                token: process.env.NEXT_PUBLIC_PADDLE_TOKEN,
                pwCustomer: {
                    id: checkoutLink.customer_id
                }
            });
            setIsInitialized(true);
        }
    }, [checkoutLink, isInitialized, pathname]);

    return null;
}
